import QuantityView from "../view/quantity.js";
import TotalPriceView from "../view/total-price.js";

import {
  formatNumber
} from "../../../utils/format-number.js";

import {
  declinationNumber
} from "../../../utils/declination-number.js";

import {
  ActionType
} from "../const.js";

import {
  QUANTITY_UNIT_MEASURE,
  PRICE_CURRENCY
} from "../lexicon.js";

export default class CartSummary {
  constructor(items) {
    this._items = items;

    this._views = [];

    this._handleCartDataChange = this._handleCartDataChange.bind(this);
  }

  init() {
    Array.from(this._items)
      .forEach((item) => {
        const view = {};
        view.quantity = new QuantityView(item.quantity);

        if (item.totalPrice) {
          view.totalPrice = new TotalPriceView(item.totalPrice);
        }

        this._views.push(view);
      });

    if (window.CartData) {
      window.CartData.addObserver(this._handleCartDataChange);
    }
  }

  _change(payload) {
    if (!payload) {
      return;
    }

    if (payload.success && payload.success === false) {
      return;
    }

    if (payload.totalPositions === 0) {
      return;
    }

    this._views.forEach((view) => {
      view.quantity.setValue(`${payload.totalPositions}\u00A0${declinationNumber(payload.totalPositions, QUANTITY_UNIT_MEASURE)}`);

      if (view.totalPrice) {
        view.totalPrice.setValue(`${formatNumber(payload.totalCost, 2, `,`, `\u00A0`)} ${PRICE_CURRENCY}`);
      }
    });
  }

  _handleCartDataChange(action, payload) {
    switch (action) {
      case ActionType.REMOVE:
      case ActionType.REMOVE_QUANTITY:
      case ActionType.ADD_QUANTITY:
      case ActionType.SUBMIT:
      case ActionType.INVALID_CHECK:
      case ActionType.BLUR:
      case ActionType.CHANGE:
        this._change(payload);
        break;
    }
  }
}
